import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import RSVP from 'rsvp';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';

export default Route.extend({
  fundsService: service(),
  store: service(),
  storeCache: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    let user = this.modelFor('admin.users.show');
    let userId = get(user, 'id');
    let storeCache = this.storeCache;
    let promise = RSVP.hash({
      fund: this.store.findRecord('admin/fund', params.fundId),
      userFunds: this.store.query('admin/user-fund', {
        filter: { user_id: userId },
      }),
      roles: storeCache.findAll('admin/role'),
    });
    return promise.then((data) => {
      let userFundRecord = data.userFunds.find(
        (userFund) => userFund.fundId === params.fundId,
      );
      let userFundChangeset = new Changeset(userFundRecord);
      if (isEmpty(get(userFundRecord, 'role'))) {
        set(userFundChangeset, 'role', get(user, 'role'));
      }
      return {
        user: user,
        roles: data.roles,
        fund: data.fund,
        userFundRecords: data.userFunds.slice(),
        userFundRecord: userFundRecord,
        userFundChangeset: userFundChangeset,
      };
    });
  },
});
